import { aspenApi as api, getStrategyDetail } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import type { IReqStrategyDetail, IRes } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";

/**
 * 获取strategy产品详情。
 * @param {IReqStrategyDetail} params - 获取strategy产品详情所需的参数。
 */
// ADGM未开放Strategy功能。暂时没有测试场景
export const useFetchStrategyDetail = (params: IReqStrategyDetail) => {
  const apiPath = api.strategies.strategyDetail;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<IRes>(queryKey);

  const { error, data, isLoading, refetch, isFetching, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    queryFn: () => {
      return getStrategyDetail(params).then(res => {
        return res?.data;
      });
    },
    placeholderData: cacheData,
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading, isFetching };
};
